import { Col, Input, Row } from 'reactstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';

const ClearIndicator = (props) => {
  const {
    children = 'borrar todo',
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
      <div style={{ padding: '0px 5px' }}>{children}</div>
    </div>
  );
};

ClearIndicator.propTypes = {
  children: PropTypes.node,
  getStyles: PropTypes.func.isRequired,
  innerProps: PropTypes.shape({ ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]) })
    .isRequired,
};

const FiltrosFila2 = ({
  isTableNotLoading,
  bd,
  headquarterList,
  course,
  coursesList,
  state,
  statesList,
  center,
  centersList,
  userOU,
  handleHeadquarter,
  handleCourses,
  handleState,
  handleCenters,
}) => (
  <Row className="mt-auto mt-md-2">
    <Col sm="3">
      <label htmlFor="centros" className="form-label">
        Centro
      </label>
      <select
        className="form-select"
        name="centros"
        id="centros"
        onChange={handleHeadquarter}
        disabled={!isTableNotLoading}
        value={bd}
      >
        {headquarterList !== ''
          ? headquarterList.map((option, idx) => (
              <option key={`${option.codigo}-${idx}`} value={option.codigo}>
                {option.nombre}
              </option>
            ))
          : ''}
      </select>
    </Col>
    <Col sm="4">
      <label htmlFor="cursos" className="form-label">
        Curso
      </label>
      <select
        className="form-select"
        name="cursos"
        id="cursos"
        onChange={handleCourses}
        disabled={!isTableNotLoading}
        value={course}
      >
        {coursesList !== ''
          ? coursesList.map((option) => (
              <option key={option.IdPlan} value={option.ciclo}>
                {option.ciclo}
              </option>
            ))
          : ''}
      </select>
    </Col>
    <Col sm="2">
      <label htmlFor="estado" className="form-label">
        Estado
      </label>
      <select
        className="form-select"
        name="estado"
        id="estado"
        onChange={handleState}
        disabled={!isTableNotLoading}
        value={state}
      >
        {statesList !== ''
          ? statesList.map((option) => (
              <option key={option.id} value={option.id}>
                {option.descripcion}
              </option>
            ))
          : ''}
      </select>
    </Col>
    <Col sm="3">
      <label htmlFor="centroestudio" className="form-label">
        Centro de estudios
      </label>
      {userOU.idCedesca > 0 ? (
        <Input type="text" name="centroFormacion" placeholder={userOU.centro} disabled />
      ) : (
        <Select
          options={centersList}
          closeMenuOnSelect={false}
          value={center}
          isMulti
          onChange={handleCenters}
          disabled={!isTableNotLoading}
          components={{ ClearIndicator }}
          placeholder="Seleccionar..."
        />
      )}
    </Col>
  </Row>
);

FiltrosFila2.propTypes = {
  isTableNotLoading: PropTypes.bool,
  bd: PropTypes.string,
  headquarterList: PropTypes.array,
  course: PropTypes.string,
  coursesList: PropTypes.array,
  state: PropTypes.string,
  statesList: PropTypes.array,
  center: PropTypes.string,
  centersList: PropTypes.array,
  userOU: PropTypes.object.isRequired,
  handleHeadquarter: PropTypes.func,
  handleCourses: PropTypes.func,
  handleState: PropTypes.func,
  handleCenters: PropTypes.func,
};

export default FiltrosFila2;
